var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "wkb-gene-set-provenance" },
    [
      _c(
        "h4",
        {
          staticClass: "wkb-inspector-section-heading",
          attrs: { title: _vm.sectionHeading },
        },
        [_vm._v(" " + _vm._s(_vm.sectionHeading) + " ")]
      ),
      !_vm.geneSetId
        ? _c("p", { staticClass: "wkb-gene-set-provenance-note" }, [
            _vm._v(
              " Provenance detail is unavailable for this gene set section. "
            ),
          ])
        : [
            _vm.loading
              ? _c(
                  "p",
                  {
                    staticClass: "wkb-gene-set-provenance-note",
                    attrs: { role: "status" },
                  },
                  [_vm._v(" Loading provenance… ")]
                )
              : _vm.error
              ? _c(
                  "p",
                  {
                    staticClass: "wkb-gene-set-provenance-error",
                    attrs: { role: "alert" },
                  },
                  [_vm._v(" " + _vm._s(_vm.error) + " ")]
                )
              : _vm.parsed
              ? [
                  _c(
                    "div",
                    { staticClass: "wkb-gene-set-provenance-toolbar" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "wkb-gene-set-provenance-tabs",
                          attrs: {
                            role: "tablist",
                            "aria-label": "Gene set provenance views",
                          },
                        },
                        _vm._l(_vm.tabs, function (tab) {
                          return _c(
                            "button",
                            {
                              key: tab.id,
                              staticClass: "wkb-gene-set-provenance-tab",
                              class: { "is-active": _vm.activeTab === tab.id },
                              attrs: {
                                id: _vm.tabButtonId(tab.id),
                                type: "button",
                                role: "tab",
                                "aria-selected":
                                  _vm.activeTab === tab.id ? "true" : "false",
                                "aria-controls": _vm.tabPanelId(tab.id),
                              },
                              on: {
                                click: function ($event) {
                                  _vm.activeTab = tab.id
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(tab.label) + " ")]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                  _vm.activeTab === "provenance"
                    ? _c(
                        "div",
                        {
                          staticClass: "wkb-gene-set-provenance-panel",
                          attrs: {
                            id: _vm.tabPanelId("provenance"),
                            role: "tabpanel",
                            "aria-labelledby": _vm.tabButtonId("provenance"),
                          },
                        },
                        [
                          _c("WorkspaceGeneSetProvenanceViz", {
                            attrs: {
                              network: _vm.parsed.provenanceNetwork,
                              height: _vm.provenanceVizHeight,
                              "aria-label": "Gene set provenance graph",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeTab === "graph_table",
                          expression: "activeTab === 'graph_table'",
                        },
                      ],
                      staticClass: "wkb-gene-set-provenance-panel",
                      attrs: {
                        id: _vm.tabPanelId("graph_table"),
                        role: "tabpanel",
                        "aria-labelledby": _vm.tabButtonId("graph_table"),
                      },
                    },
                    [
                      _c("WorkspaceEvidenceTable", {
                        attrs: {
                          rows: _vm.parsed.graphTableRows,
                          columns: _vm.graphTableColumns,
                          "page-size": 10,
                          bordered: false,
                          "empty-note": "No provenance edges found.",
                          "pagination-label": "Provenance graph pages",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeTab === "genes",
                          expression: "activeTab === 'genes'",
                        },
                      ],
                      staticClass: "wkb-gene-set-provenance-panel",
                      attrs: {
                        id: _vm.tabPanelId("genes"),
                        role: "tabpanel",
                        "aria-labelledby": _vm.tabButtonId("genes"),
                      },
                    },
                    [
                      _c("WorkspaceEvidenceTable", {
                        attrs: {
                          rows: _vm.parsed.geneRows,
                          columns: _vm.geneTableColumns,
                          "page-size": 10,
                          bordered: false,
                          "empty-note": "No genes listed for this gene set.",
                          "pagination-label": "Gene list pages",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeTab === "download_regenerate",
                          expression: "activeTab === 'download_regenerate'",
                        },
                      ],
                      staticClass:
                        "wkb-gene-set-provenance-panel wkb-gene-set-regenerate-panel",
                      attrs: {
                        id: _vm.tabPanelId("download_regenerate"),
                        role: "tabpanel",
                        "aria-labelledby": _vm.tabButtonId(
                          "download_regenerate"
                        ),
                      },
                    },
                    [
                      _c("p", { staticClass: "wkb-gene-set-regenerate-copy" }, [
                        _vm._v(
                          " Taking you to our agentic workspace. It's preloaded with the source files and analyses behind this gene set, so you can reproduce it and trace its provenance alongside an AI agent. "
                        ),
                      ]),
                      _vm._m(0),
                      _c(
                        "button",
                        {
                          staticClass: "wkb-gene-set-regenerate-copy-btn",
                          attrs: {
                            type: "button",
                            disabled: !_vm.canCopyGeneSetInformation,
                            title:
                              "Copy gene set provenance URL and assistant intention",
                          },
                          on: { click: _vm.onCopyGeneSetInformation },
                        },
                        [_vm._v(" Copy gene set information ")]
                      ),
                      _vm.copyFeedback
                        ? _c(
                            "p",
                            {
                              staticClass:
                                "wkb-gene-set-regenerate-copy-feedback",
                              attrs: { role: "status" },
                            },
                            [_vm._v(" " + _vm._s(_vm.copyFeedback) + " ")]
                          )
                        : _vm._e(),
                      _c(
                        "button",
                        {
                          staticClass: "wkb-gene-set-regenerate-open",
                          attrs: {
                            type: "button",
                            disabled: !_vm.canOpenProvenanceExplorer,
                            title: _vm.provenanceExplorerButtonTitle,
                          },
                          on: { click: _vm.onOpenProvenanceExplorer },
                        },
                        [_vm._v(" Open provenance explorer ")]
                      ),
                      !_vm.canOpenProvenanceExplorer
                        ? _c(
                            "p",
                            { staticClass: "wkb-gene-set-regenerate-footnote" },
                            [
                              _vm._v(
                                " Provenance explorer link is not configured yet. "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeTab === "biology",
                          expression: "activeTab === 'biology'",
                        },
                      ],
                      staticClass: "wkb-gene-set-provenance-panel",
                      attrs: {
                        id: _vm.tabPanelId("biology"),
                        role: "tabpanel",
                        "aria-labelledby": _vm.tabButtonId("biology"),
                      },
                    },
                    [
                      _vm.biologyTableRows.length
                        ? _c("WorkspaceEvidenceTable", {
                            attrs: {
                              rows: _vm.biologyTableRows,
                              columns: _vm.biologyTableColumns,
                              "page-size": 20,
                              bordered: false,
                              "empty-note":
                                "No biology context metadata is available for this gene set.",
                              "pagination-label": "Biology context pages",
                            },
                          })
                        : _c(
                            "p",
                            { staticClass: "wkb-gene-set-provenance-note" },
                            [
                              _vm._v(
                                " No biology context metadata is available for this gene set. "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "wkb-gene-set-regenerate-copy" }, [
      _c("strong", [_vm._v("Open provenance explorer")]),
      _vm._v(" opens that workspace in a new tab. First, use "),
      _c("strong", [_vm._v("Copy gene set information")]),
      _vm._v(
        " below, then paste it into the workspace after you are redirected—the agent needs those details to know which gene set you are working with. "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }